<template>
  <div class="q-col-sm-12 q-col-md-3 q-p-0 promoted-product__container q-d-md-none q-d-xl-block ">
    <PromotedProductHeader v-if="!isMobileView" :promoted-product-header="promotedProductHeader"/>
    <PromotedProduct :promoted-product="promotedProduct" :key="promotedProduct.id"/>
  </div>
</template>
<script lang="ts" setup>
import PromotedProduct from "./PromotedProduct.vue";
import PromotedProductHeader from './PromotedProductHeader.vue'
import {defineProps} from "vue";
import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";


defineProps(['promotedProductHeader', 'promotedProduct'])
const mobileViewStore = useMobileViewStore();
const {isMobileView} = storeToRefs(mobileViewStore)


</script>
<style>
.promoted-product__container {
  border-right: 1px solid #f0f2f6;
}

</style>